import request from "./client";

export type MaintenanceIssueRecord = {
  id: number;
  property_id?: number | null;
  room_id?: number | null;
  reported_by?: number | null;
  title: string;
  description?: string | null;
  priority: string;
  status: string;
  reported_at?: string;
  resolved_at?: string | null;
};

export async function getMaintenanceIssues() {
  return request<MaintenanceIssueRecord[]>("/api/maintenance-issues");
}

export async function createMaintenanceIssue(payload: Record<string, unknown>) {
  return request<MaintenanceIssueRecord>("/api/maintenance-issues", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateMaintenanceIssue(
  id: number,
  payload: Record<string, unknown>,
) {
  return request<MaintenanceIssueRecord>(`/api/maintenance-issues/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function deleteMaintenanceIssue(id: number) {
  return request<{ success: boolean }>(`/api/maintenance-issues/${id}`, {
    method: "DELETE",
  });
}
